import { CameraSubject } from 'streem-sdk-protobuf';
import { createRoomStatusObservable, } from '../../util/create_room_status_observable';
import { validateConfigShape } from '../../util/validate_config_shape';
import { RoomSession } from './room_session';
export class OnSiteRoomSession extends RoomSession {
    static async initialize(config) {
        return new OnSiteRoomSession(config, await super.buildWallSyncClient(config));
    }
    constructor(config, wallSyncClient) {
        super(config, wallSyncClient);
        this.config = config;
        validateConfigShape(['onEnd', 'localUserId', 'localDeviceId', 'remoteUserId', 'roomId'], config);
        this.status = createRoomStatusObservable(this.room.roomStatus, this.room.localParticipantStatus, this.room.remoteParticipantStatus, this.invitationController.incomingInvitationStatus);
    }
    async startOnSiteCall() {
        await this.connect();
        await this.media.createHostTracks();
        await this.media.connect(this.config.roomId, this.config.localUserId);
    }
}
OnSiteRoomSession.canSendCameraSubjects = [
    CameraSubject.CAMERA_SUBJECT_WORLD,
];
//# sourceMappingURL=onsite_room_session.js.map